import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
    editComplaint,
    fetchComplaints,
} from '../../app/reducers/Complaints/complaintSlice';
import {
    fetchEmployees,
    getEmployees,
} from '../../app/reducers/Users/EmployeeSlice';
import ModalBasic from '../../components/infrastructure/Modals/ModalBasic';
import PrimaryButton from '../../components/infrastructure/Buttons/PrimaryButton';
import FormikSelectGroup from '../../components/formik/FormikSelectGroup';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { generateEmployeeOptions } from '../../utils/Utils';

const AssignTechnicianModal = ({
    isAssignTechnicianBtnOpen,
    setIsAssignTechnicianBtnOpen,
    assignTechnicianData,
    page,
    status,
}) => {
    const dispatch = useDispatch();
    const { employees } = useSelector(getEmployees); // that redux call from it parent 




    const assignedFormik = useFormik({
        enableReinitialize: true,
        initialValues: {
            ...assignTechnicianData,
            assignedId: '',
            assignedTo: '',
        },
        validationSchema: Yup.object({
            assignedId: Yup.string().required('Please select a technician'),
        }),
        onSubmit: async (values) => {
            await dispatch(editComplaint({ ...values, status: 'InProgress' }));
            await dispatch(
                fetchComplaints({
                    populate: true,
                    page,
                    status,
                })
            );
            setIsAssignTechnicianBtnOpen(false);
            assignedFormik.resetForm();
        },
    });

    return (
        <ModalBasic
            title={`Assign Technician`}
            setModalOpen={setIsAssignTechnicianBtnOpen}
            modalOpen={isAssignTechnicianBtnOpen}
            max_width="max-w-md"
        >
            <form
                onSubmit={assignedFormik.handleSubmit}
                className="flex flex-col gap-4 p-5 min-h-[260px]"
            >
                <FormikSelectGroup
                    label="Select Technician"
                    name="assignedId"
                    formik={assignedFormik}
                    options={generateEmployeeOptions(employees?.docs)}
                    onChange={(selectedOption) => {
                        assignedFormik.setFieldValue(
                            'assignedId',
                            selectedOption.value
                        );
                        assignedFormik.setFieldValue(
                            'assignedTo',
                            selectedOption.label
                        );
                    }}
                />
                <div className="mt-auto">
                    <PrimaryButton
                        type="submit"
                        disabled={assignedFormik.isSubmitting}
                        className="w-full"
                    >
                        {assignedFormik.isSubmitting ? 'Assigning...' : 'Assign'}
                    </PrimaryButton>
                </div>
            </form>
        </ModalBasic>
    );
};

export default AssignTechnicianModal;
